import {useCallback} from 'react';

import {ReviewNoteType} from '../../../../../service/reviews/reviews-notes';

import {NewNote} from './new-note/new-note';

type ReviewNoteListItemPropsType = {
    allNotes: Array<ReviewNoteType>;
    note: ReviewNoteType;
    reviewId: number;
    syncNotes: (notes: Array<ReviewNoteType>) => void;
};

export function ReviewNoteListItem(props: ReviewNoteListItemPropsType): JSX.Element {
    const {allNotes, note, reviewId, syncNotes} = props;

    const handleNoteDelete = useCallback(
        (noteId: number | string) => {
            syncNotes(allNotes.filter((reviewNote) => reviewNote.id !== noteId));
        },
        [allNotes, syncNotes]
    );

    const handleNoteEdit = useCallback(
        (data: ReviewNoteType) => {
            syncNotes(allNotes.map((reviewNote) => (reviewNote.id === data.id ? data : reviewNote)));
        },
        [allNotes, syncNotes]
    );

    return (
        <NewNote
            createdAt={note.createdAt}
            id={note.id}
            onNoteDelete={handleNoteDelete}
            onNoteEdit={handleNoteEdit}
            reviewId={reviewId}
            text={note.text}
            updatedAt={note.updatedAt}
            user={note.user}
        />
    );
}
